import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import {MatDialogRef, MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import {DocumentService} from "../../../../../../core/services/document.service";

@Component({
  selector: 'app-signing-confirm-dialog',
  templateUrl: './signing-confirm-dialog.component.html',
  styleUrls: ['./signing-confirm-dialog.component.scss']
})
export class SigningConfirmDialogComponent implements OnInit, OnDestroy {

  public displayedColumns = [
    'stt',
    'name',
    'signerName',
    'page',
    'status'
  ];
  public cancelFlow = false;
  public dataTable: any = undefined;

  constructor(
    public dialogRef: MatDialogRef<SigningConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialog: MatDialog,
    private documentService: DocumentService,
  ) {
  }
  ngOnDestroy(): void {
    clearInterval(this.dataDialog.signingInteval);
  }

  ngOnInit() {
    console.log("processing", this.dataDialog.signProcessing);
    this.subscribeData();
    this.initData();
  }

  initData() {
    this.documentService.setCancelFlow(false);
    this.dataDialog.resetValue();
  }

  subscribeData() {
    this.documentService.cancelFlow.subscribe(status => {
      if (status != null || status != undefined) {
        this.cancelFlow = status
      }
    });
  }


  renderNameFile(fileId: number) {
    const file = this.dataDialog.document.mainContractAttachments.find(item => this.dataDialog.decodeId(item.id) === fileId);
    return file && file.fileName ? file.fileName : '';
  }

  renderNumberProcessing() {
    const doneSign = this.dataDialog.signProcessing.filter(item => {
      return item.done;
    });
    return doneSign.length;
  }
}
